
import { useRoute } from "vue-router";
import { qualityService } from "@/service";
import { defineComponent, ref } from "vue";

export default defineComponent({
  setup() {
    const list = ref([]);
    const route = useRoute();

    const getDetail = async () => {
      const { data } = await qualityService.pool_thead_detail({
        pool_id: route.query.id,
        recheck_num: route.query.recheck_num
      });
      list.value = data.data.map((i: any) => {
        const result = {
          ...i,
          type: i.check_type,
          _type: i.type,
          power: 1,
          num_max: i.photo_num ? i.photo_num : "",
          place: i.place_ar ? i.place_arr.map((place: any) => place.true_place).join(",") : ""
        };

        if (i.check_type == "check_file") Object.assign(result, { pic_arr: i.file_arr });

        return result;
      });
    };

    getDetail();
    return {
      list
    };
  }
});
